import { monitorValue } from "../../util/monitorUtils";

const buildDerailmentMatrixData = (monitor) => {

    const matrix = {};

    for (let car = 1; car <= 8; car++) {

        const start = ((car - 1) * 4) + 1;

        const sensorAtuado = [];
        const sensorFalha = [];

        const sensorAtuadoCategory = {};
        const sensorFalhaCategory = {};

        for (let cell = 0; cell < 4; cell++) {

            const current = start + cell;

            if (
                monitorValue(
                    monitor,
                    `sensorAtuadoCelula${current}`,
                    0
                ) !== 0
            ) {
                sensorAtuado.push(cell);

                sensorAtuadoCategory[cell] =
                    monitor?.[
                        `sensorAtuadoCelula${current}`
                    ]?.category;
            }

            if (
                monitorValue(
                    monitor,
                    `sensorFalhaCelula${current}`,
                    0
                ) !== 0
            ) {
                sensorFalha.push(cell);

                sensorFalhaCategory[cell] =
                    monitor?.[
                        `sensorFalhaCelula${current}`
                    ]?.category;
            }
        }

        matrix[car] = {
            sensorAtuado,
            sensorFalha,
            sensorAtuadoCategory,
            sensorFalhaCategory
        };
    }

    return matrix;
};

export default buildDerailmentMatrixData;